import * as React from "react";
import { useHistory } from "react-router-dom";
import { Card, Button } from "reactstrap";
import { useAuth0 } from "../../auth/react-auth0-wrapper"
import { useParams } from "react-router-dom";
import { deleteData } from "../../components/bot/storage"

export default function getCommandsCard(device, position, customButton) {

    const { eventBus, gisApi } = useAuth0();
    const { collaudoId } = useParams();

    const { push } = useHistory();

    const onClick = () => {
        push(`/`);
        push(`/collaudo/test-dashboard/${collaudoId}`);
      };

    return (
        <Card className="card-box bg-neutral-warning p-3 mb-2 border-warning" title={`COMANDI EMERGENZA`}>
            <div>
                <p>
                    {
                        "Comandi da utilizzare solamente in caso in cui si riscontrino problemi o il dispositivo rimanga in uno stato non desiderato."
                    }
                </p>
                <div>
                    <Button
                        className="m-2"
                        color="primary"
                        icon="fas fa-info"
                        onClick={async () => {
                            await gisApi.smsCommand(device.number, "p l getrecord");
                            eventBus.dispatchEvent(
                                new CustomEvent("growl", {
                                    detail: {
                                        message: {
                                            type: "success",
                                            clear: true,
                                            summary: "OPERAZIONE ESEGUITA",
                                            content: "Comando SVEGLIA inviato via SMS con successo."
                                        }
                                    }
                                })
                            );
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >SVEGLIA DISPOSITIVO VIA SMS</Button>

                    <Button
                        className="m-2"
                        color="success"
                        icon="fas fa-unlock"
                        onClick={async () => {
                            await gisApi.smsCommand(device.number, "p l setdigout 00");
                            eventBus.dispatchEvent(
                                new CustomEvent("growl", {
                                    detail: {
                                        message: {
                                            type: "success",
                                            clear: true,
                                            summary: "OPERAZIONE ESEGUITA",
                                            content: "Comando SBLOCCA inviato via SMS con successo."
                                        }
                                    }
                                })
                            );
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >SBLOCCA VIA SMS</Button>

                    <Button
                        className="m-2"
                        color="success"
                        icon="fas fa-unlock"
                        onClick={async () => {
                            await gisApi.sendComand(
                                position.deviceId,
                                "setdigout 00",
                                "sblocca",
                                false
                            );
                            eventBus.dispatchEvent(
                                new CustomEvent("growl", {
                                    detail: {
                                        message: {
                                            type: "success",
                                            clear: true,
                                            summary: "OPERAZIONE ESEGUITA",
                                            content: "Comando SBLOCCA inviato via API con successo."
                                        }
                                    }
                                })
                            );
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >SBLOCCA VIA API</Button>

                    <Button
                        className="m-2"
                        color="danger"
                        icon="fas fa-lock"
                        onClick={async () => {
                            await gisApi.smsCommand(device.number, "p l setdigout 11");
                            eventBus.dispatchEvent(
                                new CustomEvent("growl", {
                                    detail: {
                                        message: {
                                            type: "success",
                                            clear: true,
                                            summary: "OPERAZIONE ESEGUITA",
                                            content: "Comando BLOCCA inviato via SMS con successo."
                                        }
                                    }
                                })
                            );
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >BLOCCA VIA SMS</Button>

                    <Button
                        className="m-2"
                        color="danger"
                        icon="fas fa-lock"
                        onClick={async () => {
                            await gisApi.sendComand(
                                position.deviceId,
                                "setdigout 11",
                                "blocca",
                                false
                            );
                            eventBus.dispatchEvent(
                                new CustomEvent("growl", {
                                    detail: {
                                        message: {
                                            type: "success",
                                            clear: true,
                                            summary: "OPERAZIONE ESEGUITA",
                                            content: "Comando BLOCCA inviato via API con successo."
                                        }
                                    }
                                })
                            );
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >BLOCCA VIA API</Button>

                    <Button
                        className="m-2"
                        color="warning"
                        label={"COMANDO CUSTOM VIA SMS"}
                        icon="fas fa-edit"
                        onClick={async () => {
                            const command = prompt("Digita il comando CUSTOM da inviare via SMS:");
                            if (!command) return;
                            await gisApi.smsCommand(device.number, command);
                            eventBus.dispatchEvent(
                                new CustomEvent("growl", {
                                    detail: {
                                        message: {
                                            type: "success",
                                            clear: true,
                                            summary: "OPERAZIONE ESEGUITA",
                                            content: "Comando CUSTOM via SMS inviato con successo."
                                        }
                                    }
                                })
                            );
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >COMANDO CUSTOM VIA SMS</Button>

                    <Button
                        className="m-2"
                        color="warning"
                        icon="fas fa-edit"
                        onClick={async () => {
                            const command = prompt("Digitare il comando CUSTOM da inviare via API:");
                            if (!command) return;
                            await gisApi.sendComand(
                                position.deviceId,
                                command,
                                command,
                                false
                            );

                            eventBus.dispatchEvent(
                                new CustomEvent("growl", {
                                    detail: {
                                        message: {
                                            type: "success",
                                            clear: true,
                                            summary: "OPERAZIONE ESEGUITA",
                                            content: "Comando CUSTOM via API inviato con successo."
                                        }
                                    }
                                })
                            );
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >COMANDO CUSTOM VIA API</Button>

                    {!customButton && <Button
                        className="m-2"
                        color="first"
                        icon="fas fa-edit"
                        onClick={async () => {
                            const commandResult = prompt("Digitare l'evento da simulare:");
                            if (!commandResult) return;

                            const pos = JSON.parse(commandResult)
                            eventBus.dispatchEvent(
                                new CustomEvent("GISRESULT", {
                                    detail: {
                                        position: pos
                                    }
                                })
                            );
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >SIMULA EVENTO</Button>
                    }

                    <Button
                        className="m-2"
                        color="secondary"
                        label={"RICOMINCIA IL COLLAUDO"}
                        icon="fas fa-redo"
                        onClick={async () => {
                            if (confirm('Tutti i dati relativi ai test eseguiti sul collaudo verranno persi. Sicuro di voler proseguire?')) {
                                await deleteData(collaudoId);
                                onClick();
                            }
                        }}
                        style={{ marginRight: "10px", marginTop: "5px" }}
                    >RICOMINCIA IL COLLAUDO</Button>

                </div>
            </div>
        </Card>
    )
}
